// extracted by mini-css-extract-plugin
export default {"messageContainer":"withComponent__messageContainer--2K5"};